<template>
  <div
    :style="getDisplay == 0 ? 'min-height: calc(100vh - 136px)' : ''"
    v-loading="homeLoading"
    :element-loading-text="$t('拼命加载中')"
  >
    <!-- 修改 -->
    <div v-if="singleData.statusCheck == 0">
      <finishAdd
        :itemList="itemList"
        :finish_type="1"
        :addData="singleData"
        :examineType="examineType"
        @backOrderState="getList()"
        @backHome="backHome()"
      >
      </finishAdd>
    </div>
    <!-- 详情 -->
    <div v-if="singleData.statusCheck == 1">
      <div class="title" v-if="getDisplay == 0">
        <div class="title--newFont">
          <span>{{ $t("工序委外收货单详情") }}</span>
        </div>
        <div style="text-align: right">
          <el-button size="small" class="btnTwo" @click="backHome">{{
            $t("返回")
          }}</el-button>
        </div>
      </div>
      <hr />
      <!-- 内容 -->
      <div>
        <div style="height: 40px"></div>
        <myTable
          v-loading="listLoading"
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="itemList"
          :titleList="titleList"
          :tableBtnList="[]"
          ref="myTableOne"
        ></myTable>
      </div>
    </div>
  </div>
</template>
<script>
import { _debounce } from "@/utils/myUtils";
import { processOutsourcingReceive_view } from "@/api/myController/outsourcing";
import finishAdd from "@/views/outsourcingProcesses/components/finish_add.vue";
export default {
  props: {
    // 页面传进来判断入库的值
    routeType: {
      type: Array,
      default: null,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    // 审核权限
    examineType: {
      type: Number,
      default: null,
    },
    finish_type: {
      type: Number,
      default: 0,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    getDisplay: {
      type: Number,
      default: 0,
    },
    // 新增数据
    singleData: {
      default: () => ({}),
    },
  },
  components: { finishAdd },
  data() {
    return {
      htmlDataDialogState: {
        show1: false,
      },
      homeIndex: null,
      routeLevelQuery: null,
      routeLevelType: null,
      homeLoading: false,
      // 质检
      projectDetailsData: null,
      projectDetailsList: [],
      //
      flag: false,
      // ------------------基础数据
      hrefProData: {},
      listLoading: false,
      btnLoading: false,
      proList: [],
      itemListPro: [],
      itemTableBtnList: [],
      titleList: [
        {
          id: 1,
          name: this.$t("收货单号"),
          value: "processOutsourcingReceiveDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("关联单号"),
          value: "baseProcessOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 3,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 4,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 150,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 200,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 9,
          name: this.$t("本次收货数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 100,
        },
        {
          id: 9,
          name: this.$t("入库日期"),
          value: "baseInwarehouseTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    $t(val) {
      return val;
    },
    //
    async getList() {
      this.homeLoading = true;
      processOutsourcingReceive_view({
        processOutsourcingReceiveDocId: this.routeQuery.processOutsourcingReceiveDocId,
      }).then((res) => {
        try {
          res.data.data.specifications = JSON.parse(res.data.data.baseSpecgroupDesc);
        } catch (error) {
          res.data.data.specifications = [];
        }
        this.itemList = [res.data.data];
        this.singleData = res.data.data;
        this.homeLoading = false;
        // 质检信息
        try {
          this.projectDetailsData = res.data.data.proddocTestDocVo;
          try {
            res.data.data.proddocTestDocVo.valueImgCount = JSON.parse(
              res.data.data.proddocTestDocVo.valueImgList
            ).length;
          } catch (error) {
            res.data.data.proddocTestDocVo.valueImgCount = 0;
          }
          try {
            res.data.data.proddocTestDocVo.valueFileCount = JSON.parse(
              res.data.data.proddocTestDocVo.valueFileList
            ).length;
          } catch (error) {
            res.data.data.proddocTestDocVo.valueFileCount = 0;
          }
          try {
            res.data.data.proddocTestDocVo.proddocTestDocDetails.forEach((item) => {
              try {
                item.baseMaterialCount = JSON.parse(item.baseMaterialImg).length;
              } catch (error) {
                item.baseMaterialCount = 0;
              }
            });
          } catch (error) {}
          try {
            res.data.data.valueImgCount = JSON.parse(res.data.data.valueImgList).length;
          } catch (error) {
            res.data.data.valueImgCount = 0;
          }
          try {
            res.data.data.valueFileCount = JSON.parse(res.data.data.valueFileList).length;
          } catch (error) {
            res.data.data.valueFileCount = 0;
          }
          this.projectDetailsList = res.data.data.proddocTestDocVo.proddocTestDocDetails;
        } catch (error) {
          this.projectDetailsData = null;
          this.projectDetailsList = [];
        }
      });
    },
    batchNumberName(value) {
      let text = "";
      try {
        let list = JSON.parse(value);
        list.forEach((item, index) => {
          if (list.length - 1 == index) {
            text +=
              this.$t("批次号") +
              "：" +
              item.batchNumber +
              "，" +
              this.$t("使用数量") +
              "：" +
              item.quantity;
          } else {
            text +=
              this.$t("批次号") +
              "：" +
              item.batchNumber +
              "，" +
              this.$t("使用数量") +
              "：" +
              item.quantity +
              "/";
          }
        });
      } catch (error) {}
      return text;
    },
    backHome() {
      this.$emit("backHome");
    },
    htmlDataDialogClose() {
      this.htmlDataDialogState.show1 = false;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .el-descriptions-item__cell .el-descriptions-item__label .is-bordered-label {
  width: 120px !important;
}
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
